import { render, staticRenderFns } from "./StockRemove.vue?vue&type=template&id=1a34fecd&scoped=true"
import script from "./StockRemove.vue?vue&type=script&lang=js"
export * from "./StockRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34fecd",
  null
  
)

export default component.exports